import { Component, OnInit } from '@angular/core';
import { WallpaperService } from '../../services/wallpaper.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html'
})
export class CareerComponent implements OnInit {
  title = 'Opportunity At MahattaArt';
  subtitle = '';
  description = '';
  isLoading = true;

  constructor(private wallpaperService: WallpaperService) {}

  ngOnInit() {
    this.wallpaperService.getSetting().subscribe(
      (res: any) => {
        const setting = res?.data || res;
        if (setting?.career?.length) {
          this.title = setting.career[0].title || this.title;
          this.subtitle = setting.career[0].subtitle || '';
          this.description = setting.career[0].description || '';
        }
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }
}
